import React, { useEffect, useState, useRef } from 'react';
import supabase from './supabaseClient';
import { showQuotePopup } from './modal-quote-popup';

export default function DealerView() {
  const [user, setUser] = useState(null);
  const [rfqs, setRfqs] = useState([]);
  const [now, setNow] = useState(new Date());
  const lastSeenRfqs = useRef(new Set());
  const [declinedRfqs, setDeclinedRfqs] = useState(new Set());

  useEffect(() => {
    const init = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      setUser(user);
      if (user) {
        fetchRfqs(user);

        const poll = setInterval(() => {
          fetchRfqs(user);
        }, 10000);

        return () => clearInterval(poll);
      }
    };
    init();

    const tick = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(tick);
  }, []);

  const fetchRfqs = async (user) => {
    const { data, error } = await supabase
      .from('rfq_requests')
      .select(`id, user_id, expires_at, status, settlement_date, settlement_type, rfq_request_items(amount, securities(id, name, isin))`)
      .in('status', ['open', 'timed out']);

    if (error) return;

    const relevant = data.filter(r => r.user_id !== user.id);
    const nowMs = Date.now();

    for (const r of relevant) {
      const expiry = new Date(r.expires_at + 'Z').getTime();
      if (r.status === 'open' && expiry < nowMs) {
        await supabase.from('rfq_requests').update({ status: 'timed out' }).eq('id', r.id);
      }
    }

    const filtered = relevant.filter(r => r.status === 'open' && r.user_id !== user.id);
    const newRfqs = filtered.filter(r => !lastSeenRfqs.current.has(r.id));
    if (newRfqs.length > 0 && window.Notification && Notification.permission === 'granted') notifyNewRFQ();
    lastSeenRfqs.current = new Set(filtered.map(r => r.id));
    setRfqs(filtered);

    const { data: quotes } = await supabase
      .from('rfq_quotes')
      .select('rfq_id, status')
      .eq('dealer_id', user.id);

    const declined = new Set(
      quotes.filter(q => q.status === 'declined').map(q => q.rfq_id)
    );
    setDeclinedRfqs(declined);
  };

  const notifyNewRFQ = () => {
    const n = new Notification('Новая заявка RFQ', {
      body: 'Открыта новая заявка. Нажмите, чтобы перейти.',
    });
    n.onclick = () => window.location.href = '#/dealer';
  };

  const decline = async (rfq_id) => {
    if (!user) return;
    const { error } = await supabase.from('rfq_quotes').insert({
      dealer_id: user.id,
      rfq_id,
      status: 'declined'
    });
    if (error) {
      alert('Ошибка при отклонении: ' + error.message);
    } else {
      await fetchRfqs(user);
    }
  };

  const clearCompletedRfqs = async () => {
    await supabase.from('rfq_requests').delete().not('status', 'eq', 'open');
    await fetchRfqs(user);
  };

  const getTimer = (expiresAtStr) => {
    const expiry = new Date(expiresAtStr + 'Z');
    const diff = Math.floor((expiry.getTime() - Date.now()) / 1000);
    const m = String(Math.floor(diff / 60)).padStart(2, '0');
    const s = String(diff % 60).padStart(2, '0');
    const color = diff <= 0 ? 'gray' : diff <= 30 ? 'red' : diff <= 60 ? 'orange' : 'green';
    return <span style={{ color }}>{diff <= 0 ? '⏱ истек' : `${m}:${s}`}</span>;
  };

  return (
    <div style={{ padding: '2rem' }}>
      <h2>Заявки для котирования</h2>

      {typeof Notification !== 'undefined' && (
        <button onClick={async () => {
          try {
            const result = await Notification.requestPermission();
            if (result === 'granted') {
              alert('Уведомления включены');
            } else {
              alert('Уведомления не разрешены');
            }
          } catch (e) {
            alert('Ошибка запроса разрешения: ' + e.message);
          }
        }} style={{ marginBottom: '1rem' }}>Включить уведомления</button>
      )}

      <button onClick={clearCompletedRfqs} style={{ marginBottom: '1rem', marginLeft: '1rem' }}>
        Очистить завершённые заявки
      </button>

      {rfqs.length === 0 ? (
        <p>Нет открытых заявок</p>
      ) : (
        <ul>
          {rfqs.map(rfq => {
            const isDeclined = declinedRfqs.has(rfq.id);
            const isExpired = new Date(rfq.expires_at + 'Z').getTime() < Date.now();
            const disable = isDeclined || isExpired;
            return (
              <li key={rfq.id} style={{ marginBottom: '1rem' }}>
                <strong>Расчёты:</strong> {rfq.settlement_date}, {rfq.settlement_type}<br />
                <strong>До окончания:</strong>{' '}
                {disable ? <span style={{ color: 'gray' }}>{isDeclined ? 'Отклонено' : '⏱ истек'}</span> : getTimer(rfq.expires_at)}<br />
                <strong>Бумаги:</strong>
                <ul>
                  {rfq.rfq_request_items.map((item, i) => (
                    <li key={i}>{item.securities.name} ({item.securities.isin}) — {item.amount}</li>
                  ))}
                </ul>
                {!disable && (
                  <>
                    <button onClick={() => showQuotePopup(rfq)}>Принять</button>
                    <button style={{ marginLeft: 10 }} onClick={() => decline(rfq.id)}>Отклонить</button>
                  </>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
